import { api } from "@/lib/api/api";
import { args } from "@/lib/args/args";
import { CliError } from "@/lib/cli/cli-error";
import { out } from "@/lib/output/out";
import { path } from "@/lib/path/path";
import type { ApiOutputs } from "@/lib/api/api-outputs";
import type { ParsedArgs } from "@/lib/parsed/parsed-args";

export async function listCatalogBranches(
  parsed: ParsedArgs,
  asJson: boolean,
): Promise<void> {
  args.expect(parsed, { positional: 1 });
  const repoFullName = args.required(parsed, 0, "owner/repo");
  const segments = repoFullName.split("/");
  const [owner, repo] = segments;
  if (segments.length !== 2 || !owner || !repo) {
    throw new CliError(
      `Expected a repository as "owner/repo", got "${repoFullName}".`,
      2,
    );
  }

  const result = await api<ApiOutputs["catalog"]["branches"]>(
    path`/repos/${owner}/${repo}/branches`,
  );
  if (!result.result) {
    throw new CliError(`No GitHub installation covers ${repoFullName}.`);
  }
  if (asJson) {
    out.json(result);
    return;
  }
  for (const branch of result.result.branches) {
    out.line(
      branch === result.result.defaultBranch
        ? `${out.cell(branch)} ${out.paint("(default)", "dim")}`
        : out.cell(branch),
    );
  }
}
